<template>
  <div id="survey-start-page">
    <div class="mb-2">
      <span :class="`${styles.pageTitle} indigo--text ml-2`"
        ><strong>{{$t("설문 시작")}}</strong></span
      >
    </div>
    <v-card
      :class="`${
        $vuetify.breakpoint.smAndDown ? 'elevation-0' : 'elevation-10'
      }`"
    >
      <!-- 시작 페이지 타이틀 START -->
      <v-card-title primary-title class="justify-left">
        <span :class="styles.header"
          ><strong>{{ properties.survey.surveyStartTitle }}</strong></span
        >
      </v-card-title>
      <!-- 시작 페이지 타이틀 END -->
      <v-divider></v-divider>
      <!-- 시작 페이지 설명 START -->
      <v-card-text class="justify-center mt-4">
        <pre :class="`${styles.description} mx-4`">{{
          properties.survey.surveyStartDescription
        }}</pre>
      </v-card-text>
      <!-- 시작 페이지 설명 END -->
      <!-- 액션 영역 START -->
      <v-card-actions class="mt-10">
        <v-spacer></v-spacer>
        <v-btn
          large
          width="140"
          max-width="300"
          :color="themeColor"
          dark
          class="text-h6 mb-4 rounded-lg"
          @click="startSurvey"
          ><strong>{{ properties.survey.surveyStartButton }}</strong></v-btn
        >
        <v-spacer></v-spacer>
      </v-card-actions>
      <!-- 액션 페이지 타이틀 END -->
    </v-card>
  </div>
</template>

<script>
import { $startSurvey } from "@/redsurvey/api/survey";
export default {
  props: {
    properties: {
      type: Object,
    },
    rid: {
      type: String,
      required: true,
    },
    targetKey: {
      type: String,
    },
    isPreview: {
      type: Boolean,
      default: false,
    },
    themeColor: {
      type: String,
      default: "primary"
    }

  },
  computed: {
    styles() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return {
            pageTitle: "text-h6",
            header: "text-subtitle-1",
            description: "text-subtitle-1 content-description mx-5",
          };
        default:
          return {
            pageTitle: "text-h5",
            header: "text-h6",
            description: "text-subtitle-1 content-description mx-5",
          };
      }
    },
  },
  methods: {
    async startSurvey() {
      this.$emit("loading", true);
      try {
        const params = {
          k: this.targetKey,
          r: this.rid,
        };
        const surveyId = this.properties.survey.surveyId;
        if(this.isPreview) {
          // 미리보기 모드일 때
          this.$emit("next", "IN_PROGRESS");
        } else {
          const { data } = await $startSurvey(surveyId, params);
          this.$emit("next", data.result);
        }
      } catch (e) {
        this.$rxSnackbar("error", this.$t("common.msg.unexpected_error"));
      } finally {
        this.$emit("loading", false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.content-description {
  white-space: pre-wrap;
}
</style>